

import React, { useEffect, useState } from 'react';
import { Calendar, Clock } from 'lucide-react';
import AdminAppBody from '../../../../components/admin/AdminAppBody';
import useApiCallHooks from '../../../../hooks/useApiCallHooks';
import { Link, useParams } from 'react-router-dom';
import { FaEdit } from 'react-icons/fa';

const  MentorStudentListProfile = () => {
  const { slug } = useParams(); // ← Call the hook

  const [key, setKey] = useState('overview');
  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
  const [data, setData] = useState({});

  useEffect(() => {
    callAPI('get', `mentor/student-profile/${slug}`);

  }, []);

  useEffect(() => {
    if (statusCode === 200 && responce?.data) {
      setData(responce.data);
    }
  }, [responce, statusCode]);

  const student = data?.student || {};
  const experiences = responce?.data?.experiences || [];
  const projects = responce?.data?.projects || {};
  const assessment = responce?.data?.assessment || "0/0";

  const [completedTasksCount, totalTasksCount] = data?.task?.split('/')?.map(Number) || [0, 0];
  const [completedSessionsCount, totalSessionsCount] = data?.session?.split('/')?.map(Number) || [0, 0];
  const [completedAssessments, totalAssessments] = data?.assessment?.split('/')?.map(Number) || [0, 0];

  const recentActivities = [
    {
      type: 'assessment',
      title: 'Basics ( Basic)',
      score: '0.00%',
      date: '4 Jun 2025',
      time: '2:55 PM',
    },
    {
      type: 'task',
      title: 'Find What is Business Analyst',
      date: '16 Apr 2025',
      time: '4:45 PM',
    },
    {
      type: 'task',
      title: 'mnbcnmd nmc',
      date: '15 Apr 2025',
      time: '7:09 PM',
    },
    {
      type: 'task',
      title: 'what is figma',
      date: '15 Apr 2025',
      time: '6:24 PM',
    },
    {
      type: 'session',
      title: 'Hooks',
      date: '14 Apr 2025',
      time: '5:00 PM',
    },
  ];

  const buttonPrimaryStyle = {
    backgroundColor: '#004AAD',
    border: '1px solid #004AAD',
    color: 'white',
    fontWeight: '600',
    borderRadius: '6px',
    padding: '8px 20px',
    fontSize: '15px',
    transition: 'all 0.3s ease-in-out',
  };

  const buttonOutlineStyle = {
    backgroundColor: 'white',
    border: '1px solid #004AAD',
    color: '#004AAD',
    fontWeight: '600',
    borderRadius: '6px',
    padding: '8px 20px',
    fontSize: '15px',
    transition: 'all 0.3s ease-in-out',
  };

  return (
 
    <AdminAppBody
   loading={loading}
      content={
       <div className="p-4">
  <h4 className="fw-bold mb-1">Profile</h4>
  <p className="text-secondary">View and Manage Your Information</p>

  <div className="row mt-4">
    {/* Profile Card */}
    <div className="col-md-4">
      <div className="card p-3 shadow-sm">
          
        <div className="text-center">
          
          <img
            src={student.profile_pic}
            alt="Profile"
            className="rounded-circle border border-primary"
            style={{ width: '130px', height: '130px', objectFit: 'cover' }}
          />
          <h4 className="fw-bold mt-3 mb-1">
            {student.first_name} {student.last_name}
          </h4>
          <p className="text-secondary mb-2">{student.headline || 'No headline available'}</p>
          <hr />
         <p className="mb-2">
  <i className="bi bi-envelope me-2"></i>
  {student.email || 'N/A'}
</p>

<p className="mb-2">
  <i className="bi bi-telephone me-2"></i>
  {student.mobile_no || 'N/A'}
</p>

<p className="mb-2">
  <i className="bi bi-mortarboard me-2"></i>
  {student.higher_education || 'N/A'}
</p>

          <div className="d-flex justify-content-center gap-2 mt-3">
            <button style={buttonPrimaryStyle}>Chatbot</button>
            <button
              style={buttonOutlineStyle}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#004AAD';
                e.target.style.color = 'white';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'white';
                e.target.style.color = '#004AAD';
              }}
            >
              Resume
            </button>
          </div>
        </div>
      </div>
    </div>

    {/* Tab + Content */}
    <div className="col-md-8">
      {/* Tab Menu */}
      <div className="card p-3 mb-3 shadow-sm">
        <div className="d-flex justify-content-around flex-wrap gap-2">
          {['overview', 'payment', 'about'].map((tab) => (
            <div
              key={tab}
              onClick={() => setKey(tab)}
              style={{
                ...(key === tab ? buttonPrimaryStyle : buttonOutlineStyle),
                padding: '6px 30px',
                fontWeight: 'bold',
                textAlign: 'center',
                cursor: 'pointer',
              }}
              onMouseEnter={(e) => {
                if (key !== tab) {
                  e.target.style.backgroundColor = '#004AAD';
                  e.target.style.color = 'white';
                }
              }}
              onMouseLeave={(e) => {
                if (key !== tab) {
                  e.target.style.backgroundColor = 'white';
                  e.target.style.color = '#004AAD';
                }
              }}
            >
              {tab.charAt(0).toUpperCase() + tab.slice(1)}
            </div>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div>
        {key === 'overview' && (
          <>
            <div className="d-flex gap-3 mb-3 flex-wrap">
              {[
                { label: 'Tasks Completed', count: completedTasksCount, total: totalTasksCount },
                { label: 'Sessions Completed', count: completedSessionsCount, total: totalSessionsCount },
                { label: 'Assessments Completed', count: completedAssessments, total: totalAssessments },
              ].map((item, idx) => (
                <div key={idx} className="card flex-fill text-center p-3 shadow-sm" style={{ minWidth: '250px' }}>
                  <p className="text-secondary mb-1">{item.label}</p>
                  <h4 className="fw-bold">{item.count}/{item.total}</h4>
                  <div className="progress">
                    <div
                      className="progress-bar"
                      role="progressbar"
                      style={{ width: `${(item.count / item.total) * 100 || 0}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>

            <div className="card p-3 shadow-sm" style={{ maxHeight: '300px', overflowY: 'auto' }}>
              <h5 className="fw-bold mb-3">Recent Activity</h5>
              {recentActivities.map((activity, idx) => (
                <div className="d-flex mb-3 align-items-start gap-3" key={idx}>
                  <div className="rounded-circle bg-success bg-opacity-25 p-2">
                    <i className="bi bi-check-circle-fill text-success"></i>
                  </div>
                  <div>
                    <p className="m-0 fw-bold">
                      {activity.type === 'assessment'
                        ? <>Completed Assessment "{activity.title}" - Score: <span className="text-danger">{activity.score}</span></>
                        : activity.type === 'session'
                          ? <>Completed Session "{activity.title}"</>
                          : <>Completed Task "{activity.title}"</>}
                    </p>
                    <small className="text-secondary d-flex gap-2 align-items-center">
                      <Calendar size={14} /> {activity.date} <Clock size={14} /> {activity.time}
                    </small>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}

        {key === 'payment' && (
          <div className="card p-3 shadow-sm">
            <h5>💳 Payment Summary</h5>
            <p className="text-muted">Payment information will go here...</p>
          </div>
        )}

        {key === 'about' && (
          <div className="card p-3 shadow-sm">
            <h5>About</h5>
            <p className="text-muted">{student.about || 'No bio available.'}</p>

            <h5>Skills</h5>
            <p className="text-muted">{student.skills || 'No skills listed.'}</p>

            <h5>Address</h5>
            <p className="text-muted">{student.address || 'No address available.'}</p>

            <h5>Experience</h5>
            {experiences.length > 0 ? (
              experiences.map((exp, idx) => (
                <p key={idx} className="mb-1 text-dark">
                  Company Name: <span className="text-primary">{exp.name}</span>, Role: <span className="text-success">{exp.job_role}</span>
                </p>
              ))
            ) : (
              <p className="text-muted">No experience data available.</p>
            )}

         <h5>Projects</h5>
{projects.length > 0 ? (
  projects.map((proj, idx) => (
    <div key={idx} className="mb-3">
      <p className="fw-bold text-dark">{proj.name}</p>
      <p className="text-muted">{proj.description}</p>
      <p className="text-secondary"><strong>Key Skill:</strong> {proj.key_skill}</p>
    </div>
  ))
) : (
  <p className="text-muted">No project listed.</p>
)}


            <h5>Education</h5>
            <p className="text-muted">{student.higher_education || 'No education data available.'}</p>
          </div>
        )}
      </div>
    </div>
  </div>
</div>

      }
    />
  );
};

export default MentorStudentListProfile;

